(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _User = require('../models/User');

var _User2 = _interopRequireDefault(_User);

var _ResolutionCenter = require('../models/ResolutionCenter');

var _ResolutionCenter2 = _interopRequireDefault(_ResolutionCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeController =
/*@ngInject;*/
function HomeController($scope, $timeout, $interval, $http, $location, $route, $routeParams, $sce, $window) {
	_classCallCheck(this, HomeController);

	var content = $window.translations,
	    resCenter = new _ResolutionCenter2.default($window.resolution_initial_list);

	$scope.loc = $location.search();

	$scope.content = content;

	$scope.resolution_center = {
		select_option: [{ name: 'Choose one...' }],
		initial_list: resCenter.getInitialList(),
		second_list: false,
		resolution: $sce.trustAsHtml('')
	};

	$scope.legalPagesInitial = function () {
		var actions = window.actions;

		$scope.legalContent = content[actions.content];

		if ($scope.loc.find) {
			$timeout(function () {
				var section = $('div#address'),
				    position = section.offset().top;

				window.scrollTo(0, position);
				//console.log('Find position ', position);
			}, 100);
		}
	};

	$('.mt-checkbox input').on("change", function (e) {
		var isChecked = $(this).is(':checked'),
		    button = $('#saml-terms-submit-btn');

		if (isChecked) {
			button.removeAttr('disabled');
			button.click(function () {
				$scope.$apply(function () {
					$scope.saml_terms_btn = true;
				});

				$scope.samlAcceptTerms();
			});
		} else {
			button.attr('disabled', 'disabled');
			button.unbind("click");
		}
	});

	$('#res_center_initial').on("change", function (e) {
		var option = $("#res_center_initial option:selected"),
		    option_selected = $scope.resolution_center.initial_list[option.attr('key')];

		resCenter.getArticle(option_selected.article_id).then(function (value) {
			$scope.$apply(function () {
				$scope.article = $sce.trustAsHtml(value.article);
			});

			resCenter.getGroupById(value.resolution_group_id).then(function (group_value) {
				$scope.$apply(function () {
					$scope.resolution_group = group_value;
				});
			});
		});
	});

	$scope.menuClickedItem = function ($event) {
		var link = $($event.target).parents('li').find('a').attr('href');

		$window.location.href = link;
	};

	$scope.scroll_to = function (anchor) {
		var section = $('#' + anchor),
		    position = section.offset().top;

		$('html, body').animate({
			scrollTop: position
		}, 200);
	};

	$scope.samlAcceptTerms = function () {
		var user = new _User2.default($http);

		user.samlAcceptTerms({ 'policy_accepted': true }).then(function (data) {
			$timeout(function () {
				$scope.$apply(function () {
					$scope.saml_terms_btn = false;
				});

				$window.location.href = '/user/dashboard';
			}, 1000);
		});

		console.log('User has accepted');
	};
};

exports.default = HomeController;

},{"../models/ResolutionCenter":6,"../models/User":8}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _User = require('../models/User');

var _User2 = _interopRequireDefault(_User);

var _Payment = require('../models/Payment');

var _Payment2 = _interopRequireDefault(_Payment);

var _FeatureDetails = require('../models/features/FeatureDetails');

var _FeatureDetails2 = _interopRequireDefault(_FeatureDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LandingpageController =
/*@ngInject;*/
function LandingpageController($scope, $timeout, $interval, $http, $location, $route, $routeParams, $sce, $window) {
	var _this = this;

	_classCallCheck(this, LandingpageController);

	var content = window.translations,
	    user = new _User2.default(),
	    landing_page_images = window.landing_page_images,
	    scrollTime = 0.3,
	    scrollDistance = 130,
	    brandCode = window.brand_code,
	    brandProducts = window.brand_products,
	    brandColorType = window.brand_color_type;

	//Scrolling window smoothness
	$($window).on("mousewheel DOMMouseScroll", function (event) {
		event.preventDefault();

		var delta = event.originalEvent.wheelDelta / 120 || -event.originalEvent.detail / 3;
		var scrollTop = $($window).scrollTop();
		var finalScroll = scrollTop - parseInt(delta * scrollDistance);

		TweenMax.to($window, scrollTime, {
			scrollTo: { y: finalScroll, autoKill: true },
			ease: Power1.easeOut,
			autoKill: true,
			overwrite: 5
		});
	});

	var feature_details = new _FeatureDetails2.default($sce, content, brandCode, brandColorType, landing_page_images);

	$scope.features_col = 'col-md-3';
	$scope.how_it_works = {};

	if (Object.keys(window.landing_page_features).length != Object.keys(feature_details).length) {
		for (var index in window.landing_page_features) {
			for (var i in feature_details) {
				if (i == window.landing_page_features[index]) {
					$scope.how_it_works[i] = feature_details[i];
				}
			}
		}
	} else {
		$scope.how_it_works = feature_details;
	}

	var count = 0;

	for (var _i in $scope.how_it_works) {
		$scope.how_it_works[_i].description.position = 'right';

		if (count % 2 == 1) {
			$scope.how_it_works[_i].description.position = 'left';
			$scope.how_it_works[_i].description.background = '';
		}

		count++;
	}

	if (Object.keys($scope.how_it_works).length == 3) {
		$scope.features_col = 'col-md-4';
	}

	if (Object.keys($scope.how_it_works).length == 2) {
		$scope.features_col = 'col-md-6';
	}

	var screenshotImages = [];

	if (brandProducts.includes('DPS')) {
		screenshotImages.push({
			file: '/images/generali/screen/' + landing_page_images.carousel.carousel_iphone,
			alt: ''
		});
	}

	screenshotImages.push({
		file: '/images/generali/screen/' + landing_page_images.carousel.carousel_macbook,
		alt: ''
	}, {
		file: '/images/generali/screen/' + landing_page_images.carousel.carousel_ipad,
		alt: ''
	}, {
		file: '/images/generali/screen/' + landing_page_images.carousel.carousel_iphone_db,
		alt: ''
	});

	$scope.screenshots = {
		type: 'coverflow',
		delay: 5000,
		images: screenshotImages
	};
	$scope.pricings = {
		type: content['our-plan-monthly-text'],
		prices: {
			monthly: {
				type: content['our-plan-monthly-text'],
				type_name: 'monthly',
				interval: 'month',
				price: [8, 99],
				delay: '.1s'
			},
			annually: {
				type: content['our-plan-annually-text'],
				type_name: 'annually',
				interval: 'annual',
				price: [89, 99],
				delay: '.2s'
			}
		},
		delay: '.1',
		descriptions: [{ icon: 'flaticon-dashboard', text: 'Dashboard to access reports/alerts/software' }, { icon: 'flaticon-time', text: 'Real-time status of your digital footprint' }, { icon: 'flaticon-warning', text: 'Real-time alerts of data found on internet or dark web' }, { icon: 'flaticon-shield-4', text: 'Software protecting everything you enter online' }, { icon: 'flaticon-telemarketer', text: '24/7 ID Assistance' }]
	};
	$scope.price_type = content['our-plan-monthly-text'].toLowerCase();

	$scope.toggleValue = true;
	$scope.features_btn_active = false;
	$scope.payment = {
		active: false,
		curr_step: 1,
		form: []
	};

	user.getUserDetails().then(function (value) {
		//console.log(value);
	});

	$('#landingSideMenu').on('show.bs.offcanvas', function () {
		$('body .main_container').bind('touchmove', function (e) {
			e.preventDefault();
		});

		$('.main_container').click(function () {
			$('#landingSideMenu').offcanvas('hide');
		});

		$('body.dialogShowing').css('overflow', 'hidden');
	});

	$('#landingSideMenu').on('hide.bs.offcanvas', function () {
		$('body .main_container').unbind('touchmove');
		$('.main_container').unbind('click');
	});

	$('.thumbVideo .video .bg').css({
		height: $('.thumbVideo .video').css('height')
	});

	$('.thumbVideo .video').on('mouseover', function () {
		var playButton = $(this).find('svg');

		playButton.animate({
			opacity: 0.5
		}, 100);
	});

	$('.thumbVideo .video').on('mouseout', function () {
		var playButton = $(this).find('svg');

		playButton.animate({
			opacity: 1
		}, 100);
	});

	$(window).on('load', function () {
		$('#loader').fadeOut('fast', function () {
			$(this).remove();
		});
	});

	$(window).scroll(function (event) {
		var scroll_pos = $(window).scrollTop(),
		    first_pos = $('#id_monitoring').offset().top,
		    last_pos = $('#id_assistance').offset().top;

		if (scroll_pos < first_pos - 100 || scroll_pos > last_pos + 300) {
			$scope.$apply(function () {
				$scope.features_btn_active = false;
			});
		}
	});

	$timeout(function () {
		var numbers = [],
		    titles_numbers = [];

		$('.feature-block h4').each(function () {
			titles_numbers.push($(this).height());
		});

		var largestTitleNumbers = Math.max.apply(Math, titles_numbers);

		$('.feature-block h4').css('height', largestTitleNumbers);

		$('.feature-block').each(function () {
			numbers.push($(this).height());
		});

		var largestNumber = Math.max.apply(Math, numbers);

		$('.feature-block').css('height', largestNumber);
	}, 100);

	$scope.scroll_to = function (anchor, seconds) {
		var section = $('#' + anchor),
		    position = section.offset().top,
		    exclude = ['body', 'features', 'pricing', 'payment'],
		    anim_anchor = ['payment', 'body'],
		    speed = seconds === undefined ? 1000 : seconds;

		//$('#landingSideMenu').offcanvas('hide');

		if (anim_anchor.indexOf(anchor) != -1) {
			$('html, body').animate({
				scrollTop: position - 70
			}, speed, function () {
				if (exclude.indexOf(anchor) == -1) {
					$scope.$apply(function () {
						$scope.features_btn_active = true;
					});
				}
			});
		} else {
			window.scrollTo(0, position - 70);

			if (exclude.indexOf(anchor) == -1) {
				$scope.features_btn_active = true;
			}
		}
	};

	$timeout(function () {
		$scope.fadeOutInHeroIntro();
	}, 5000);

	$('.popup-video').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: true
	});

	$scope.fadeOutInHeroIntro = function () {
		var intro_hero = $('#intro-hero'),
		    hero = [{
			bg_image: 'bg-image-1',
			title: content['banner-image-1-title'],
			tagline: content['banner-image-1-description']
		}, {
			bg_image: 'bg-image-2',
			title: content['banner-image-2-title'],
			tagline: content['banner-image-2-description']
		}];

		if (intro_hero.attr('class').indexOf('bg-image-2') != -1) {
			var hero_0 = hero[0],
			    hero_1 = hero[1];

			hero[0] = hero_1;
			hero[1] = hero_0;
		}

		intro_hero.animate({
			opacity: 0
		}, 500, function () {
			intro_hero.removeClass(hero[0].bg_image);
			intro_hero.addClass(hero[1].bg_image);

			intro_hero.find('h1.hero-title').html(hero[1].title);
			intro_hero.find('p.hero-tagline').html(hero[1].tagline);

			intro_hero.animate({
				opacity: 1
			}, 500, function () {
				$timeout(function () {
					$scope.fadeOutInHeroIntro();
				}, 10000);
			});
		});
	};

	$scope.fadeInHeroText = function () {
		var heroText = $('.hero-text');

		heroText.animate({
			opacity: 1
		}, 500);
	};

	$scope.start_payment = function (type) {
		var step = $scope.payment.curr_step;

		_this.payment = new _Payment2.default($scope.pricings.prices[type.toLowerCase()], $scope.price_type, content, $sce, window.stripe);

		$scope.payment.steps = _this.payment.get_steps(step);

		$scope.payment.publish_key = _this.payment.publish_key;

		for (var i = 1; i <= $scope.payment.steps.length; i++) {
			var form = _this.payment.get_form(i);

			if ($scope.payment.form[i] === undefined) {
				$scope.payment.form[i] = {};
			}

			$scope.payment.form[i].html = $sce.trustAsHtml(form.html);
			$scope.payment.form[i].fields = form.fields;
			$scope.payment.form[i].title = $sce.trustAsHtml(form.title);
			$scope.payment.form[i].submit = form.submit;
			$scope.payment.form[i].submit_pay = form.submit_pay;
			$scope.payment.form[i].onsubmit = form.onsubmit;
		}

		$scope.payment.active = true;

		//Payment page opens up underneath "Our Plan" section and scrolls to it
		$scope.scroll_to('payment', 300);

		$('body').on('click', '.form_payment #radioBtn a', function () {
			var sel = $(this).data('title'),
			    tog = $(this).data('toggle');

			$('#' + tog).prop('value', sel);

			$('a[data-toggle="' + tog + '"]').not('[data-title="' + sel + '"]').removeClass('active').addClass('notActive');
			$('a[data-toggle="' + tog + '"][data-title="' + sel + '"]').removeClass('notActive').addClass('active');
		});
	};

	$scope.onSubmitForm = function (form, fields, step) {
		var that = _this,
		    cont = true,
		    step = _this.payment.get_steps(step, true),
		    post_data = { process: step.alias };

		return new Promise(function (resolve, reject) {
			$scope.continue_payment_btn = true;

			if ($scope.payment.curr_step < 3) {
				$(form).find('input').each(function () {
					var name = $(this).attr('name'),
					    value = $(this).val(),
					    field = {};

					$(this).popover('dispose');

					if (cont) {
						for (var i in fields) {
							if (name == fields[i].name) {
								field = fields[i];

								post_data[fields[i].name] = value;
							}
						}

						var validate = that.payment.validate(field, value);

						if (validate !== true) {
							cont = false;

							$(this).popover({ content: validate });
							$(this).popover('show');
						}
					}
				});

				if (!cont) {
					$timeout(function () {
						$scope.continue_payment_btn = false;
					}, 100);

					console.log('A problem has occurred');
				} else {
					that.payment.process_payment_form(post_data).then(function (value) {
						$timeout(function () {
							$scope.continue_payment_btn = false;
						}, 100);

						if (value.success !== undefined) {
							if (!value.success) {
								for (var i in value.content) {
									var inputField = $(form).find('input[name=' + value.content[i].type + ']');

									inputField.popover({ content: value.content[i].message });
									inputField.popover('show');
								}
							} else {
								resolve(true);
							}
						}
					});
				}
			} else {
				resolve(true);
			}
		});
	};

	$scope.payment_steps_next = function ($event, $pay) {
		var step = $scope.payment.curr_step,
		    form = $($event.currentTarget).parents('form'),
		    fields = $scope.payment.form[step].fields,
		    values = [];

		$scope.onSubmitForm(form, fields, step).then(function (value) {
			if (value === true) {
				for (var i in fields) {
					values.push({
						label: fields[i].label.replace('*', ''),
						name: fields[i].name,
						value: form.find('input[name="' + fields[i].name + '"]').val()
					});
				}

				_this.payment.save_details(values, step);

				if ($scope.payment.steps[$scope.payment.curr_step].position == 'last') {
					var confirm_details = _this.payment.confirm_details();

					$scope.payment.form[step + 1].html = $sce.trustAsHtml(confirm_details.html);
					$scope.payment.form[step + 1].title = confirm_details.title;
					$scope.payment.form[step + 1].submit = confirm_details.submit;
				}

				var payment = _this.payment;

				if ($pay !== true) {
					$scope.payment.curr_step += 1;
					$scope.payment.steps = _this.payment.get_steps($scope.payment.curr_step);
				} else {
					payment.formOnSubmit().then(function (value) {
						//Make payment
						payment.makePayment(value).then(function (value) {
							if (value.success === true) {
								$scope.payment.curr_step += 1;
								$scope.payment.steps = _this.payment.get_steps($scope.payment.curr_step);
							}
						});
					});
				}

				if ($scope.payment.curr_step == 3) {
					if (!payment.stripeActive) {
						$timeout(function () {
							var stripe = Stripe(payment.publish_key),
							    paymentRequest = stripe.paymentRequest({
								country: 'IT',
								currency: 'eur',
								total: {
									label: 'Demo Total',
									amount: 1000
								}
							}),
							    paymentDetails = {
								country: 'IT',
								currency: 'eur',
								total: {}
							};

							payment.setup_payment_details(stripe, paymentRequest, paymentDetails);
						}, 100);
					}
				}
			}
		});
	};

	$scope.payment_steps_back = function () {
		$scope.payment.curr_step -= 1;
		$scope.payment.steps = _this.payment.get_steps($scope.payment.curr_step);
	};

	$scope.togglePlan = function (type) {
		var toggleSwitch = $('div.toggle-switch'),
		    btnMonthly = toggleSwitch.find('button.monthly'),
		    btnAnnually = toggleSwitch.find('button.annually'),
		    btns = toggleSwitch.find('button'),
		    selector = toggleSwitch.find('div.selector'),
		    toggleWidth = parseInt(toggleSwitch.width()),
		    btn = btnMonthly,
		    position = 1;

		if (type == 'annually') {
			btn = btnAnnually;
			position = selector.width() + 4;
		}

		btns.css('color', '#000');
		btn.css('color', '#FFF');

		selector.animate({
			left: position
		}, 100, function () {
			$scope.$apply(function () {
				$scope.price_type = type;
			});
		});
	};
};

exports.default = LandingpageController;

},{"../models/Payment":5,"../models/User":8,"../models/features/FeatureDetails":10}],3:[function(require,module,exports){
'use strict';

var _LandingpageController = require('../controllers/LandingpageController');

var _LandingpageController2 = _interopRequireDefault(_LandingpageController);

var _HomeController = require('../controllers/HomeController');

var _HomeController2 = _interopRequireDefault(_HomeController);

var _FormatHTML = require('../services/FormatHTML');

var _FormatHTML2 = _interopRequireDefault(_FormatHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('dmsGenerali', ['ngRoute', 'ngAnimate', 'ngSanitize', 'angular-ladda']).controller('LandingpageController', _LandingpageController2.default).controller('HomeController', _HomeController2.default).directive('compile', function ($compile, $timeout) {
	return {
		restrict: 'A',
		link: function link(scope, elem, attrs) {
			$compile(elem.contents())(scope);
		}
	};
}).directive('bindHtmlCompile', ['$compile', function ($compile) {
	return {
		restrict: 'A',
		link: function link(scope, element, attrs) {
			scope.$watch(function () {
				return scope.$eval(attrs.bindHtmlCompile);
			}, function (value) {
				// In case value is a TrustedValueHolderType, sometimes it
				// needs to be explicitly called into a string in order to
				// get the HTML string.
				element.html(value && value.toString());
				// If scope is provided use it, otherwise use parent scope
				var compileScope = scope;
				if (attrs.bindHtmlScope) {
					compileScope = scope.$eval(attrs.bindHtmlScope);
				}
				$compile(element.contents())(compileScope);
			});
		}
	};
}]).filter('camelCase', function () {
	return function (input) {
		if (input === undefined) {
			return;
		}

		var str_lower = input.toLowerCase(),
		    str_split = str_lower.split(" ");

		for (var i in str_split) {
			var str = str_split[i];

			str_split[i] = str.substring(0, 1).toUpperCase() + str.substring(1);
		}

		return str_split.join(" ");
	};
}).filter('trustAsHtml', ['$sce', function ($sce) {
	return function (input) {
		return $sce.trustAsHtml(input);
	};
}]).filter('formatHtml', ['$sce', function ($sce) {
	return function (input) {
		var content = new _FormatHTML2.default();

		return content.showString(input);
	};
}]).config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
	$locationProvider.html5Mode({
		enabled: true,
		requireBase: true
	});
}]); /*
       Import all Angular components via ES6 imports and register them
     */

},{"../controllers/HomeController":1,"../controllers/LandingpageController":2,"../services/FormatHTML":11}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Model class Form
 */
var Form = function () {
	function Form() {
		_classCallCheck(this, Form);

		this.form_inputs = {
			label: '<label>[[value]]</label>',
			text: '<input type="text" class="form-control" name="[[name]]" data-toggle="popover" data-placement="bottom" value="[[value]]" [[required]]>',
			password: '<input type="password" class="form-control" name="[[name]]" data-toggle="popover" data-placement="bottom" value="[[value]]" [[required]]>',
			hidden: '<input type="hidden" class="form-control" name="[[name]]" data-toggle="popover" data-placement="bottom" value="[[value]]" />',
			radio: '<a class="btn btn-primary btn-sm [[active]]" data-toggle="[[toggle_name]]" data-title="[[data_title]]">[[display_name]]</a>',
			checkbox: '',
			dropdown: ''
		};
	}

	_createClass(Form, [{
		key: 'combine_input',
		value: function combine_input(type, name, value, colnum, required) {
			var cInput = this.input(type, name, value, required),
			    cDivCol = this.div_col(cInput, colnum);

			return cDivCol;
		}
	}, {
		key: 'input',
		value: function input(type, name, value, required) {
			var html = this.form_inputs[type];

			html = html.replace('[[name]]', name);
			html = html.replace('[[value]]', value);

			if (required) {
				html = html.replace('[[required]]', 'required');
			} else {
				html = html.replace('[[required]]', '');
			}

			return html;
		}
	}, {
		key: 'div_col',
		value: function div_col(html, colnum) {
			return '<div class="col-md-' + colnum + '">' + html + '</div>';
		}
	}, {
		key: 'form_group',
		value: function form_group(insert) {
			return '<div class="row form-group">\n\t\t\t\t\t' + insert + '\n\t\t\t\t</div>';
		}
	}, {
		key: 'validate',
		value: function validate(field, value) {
			console.log(value);

			if (value == "") {
				return field.error.empty;
			}

			switch (field.name) {
				case 'email':
					var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

					if (!pattern.test(value)) {
						return field.error.valid;
					}
					break;
			}

			return true;
		}
	}]);

	return Form;
}();

exports.default = Form;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Form = require('./Form');

var _Form2 = _interopRequireDefault(_Form);

var _Stripe2 = require('./Stripe');

var _Stripe3 = _interopRequireDefault(_Stripe2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Model class Payment
 */
var Payment = function (_Stripe) {
	_inherits(Payment, _Stripe);

	function Payment(pricing, payment_type, content, sce, stripe) {
		_classCallCheck(this, Payment);

		var _this = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this, pricing, payment_type, content, sce, stripe));

		_this.payment_type = payment_type;
		_this.form = new _Form2.default();
		_this.content = content;
		_this.sce = sce;
		_this.steps = [{
			position: 'first',
			status: '',
			icon: 'fa fa-cog',
			active: true,
			alias: 'account_setup',
			name: content['account-setup'],
			title: content['account-setup-title'],
			submit: content['continue-btn'],
			submit_pay: false,
			onsubmit: false,
			saved: {}
		}, {
			position: 'second',
			status: '',
			active: false,
			icon: 'fa fa-user',
			alias: 'profile_setup',
			name: content['profile-setup'],
			title: content['profile-setup-title'],
			submit: content['continue-btn'],
			submit_pay: false,
			onsubmit: false,
			saved: {}
		}, {
			position: 'third',
			status: '',
			active: false,
			icon: 'fa fa-credit-card',
			name: content['billing-setup'],
			title: content['billing-setup-title'],
			submit: content['pay-btn'],
			submit_pay: true,
			onsubmit: true,
			saved: {}
		}, {
			position: 'last',
			status: '',
			active: false,
			icon: 'fa fa-rocket',
			name: content.confirm,
			title: content['confirm-title'],
			submit: content.confirm,
			submit_pay: false,
			onsubmit: false,
			saved: {}
		}];
		return _this;
	}

	_createClass(Payment, [{
		key: 'get_steps',
		value: function get_steps(pos) {
			var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var steps = [],
			    json = JSON.parse(JSON.stringify(this.steps));

			for (var i in json) {
				steps[i] = json[i];

				if (i < pos - 1) {
					steps[i].status = 'done';
					steps[i].icon = 'fa fa-check';
					steps[i].active = true;
				}

				if (i == pos - 1) {
					steps[i].status = 'active';
					steps[i].active = true;
				}
			}

			if (single) {
				return this.steps[pos - 1];
			}

			return steps;
		}
	}, {
		key: 'get_form',
		value: function get_form(step) {
			var form = {
				title: this.steps[step - 1].title,
				submit: this.steps[step - 1].submit,
				submit_pay: this.steps[step - 1].submit_pay,
				onsubmit: this.steps[step - 1].onsubmit,
				fields: [],
				html: ''
			},
			    details = {};

			switch (step) {
				case 1:
					details = this.account_details();
					break;

				case 2:
					details = this.profile_setup();
					break;

				case 3:
					details = this.billing_setup();
					break;
			}

			if (details.html !== undefined) {
				form.html = details.html;
				form.fields = details.fields;
			}

			return form;
		}
	}, {
		key: 'account_details',
		value: function account_details() {
			var fields = [{ label: this.content['account-setup-email'] + ' *', name: 'email', type: 'text', required: true, error: { valid: this.content['invalid-email'], empty: this.content['field-empty'] } }, { label: this.content['account-setup-password'] + ' *', name: 'password', type: 'password', required: true, error: { empty: this.content['field-empty'] } }, { label: this.content['account-setup-confirm'] + ' *', name: 'confirm_password', type: 'password', required: true, error: { empty: this.content['field-empty'] } }];

			return this.return_html(fields);
		}
	}, {
		key: 'profile_setup',
		value: function profile_setup() {
			var fields = [{ label: this.content['profile-setup-firstname'] + ' *', name: 'first_name', type: 'text', required: true, error: { empty: this.content['field-empty'] } }, { label: this.content['profile-setup-surname'] + ' *', name: 'surname', type: 'text', required: true, error: { empty: this.content['field-empty'] } }, { label: this.content['profile-setup-phone'] + ' *', name: 'phone', type: 'text', required: true, error: { empty: this.content['field-empty'] } }];

			return this.return_html(fields);
		}
	}, {
		key: 'billing_setup',
		value: function billing_setup() {
			var fields = [{ label: this.content['billing-setup-card-name'] + ' *', name: 'card_name', type: 'text', required: true }, { label: this.content['billing-setup-card-number'] + ' *', name: 'card_number', type: 'text', required: true }, { label: this.content['billing-setup-card-cvc'] + ' *', name: 'cvc', type: 'text', required: true }, { label: this.content['billing-setup-card-expiry'] + ' *', name: 'expiration', type: 'text', required: true }];

			var html = '<div class="col-md-6 col-md-offset-3">\n\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t<svg class="credit-cards cc-unknown"><use xlink:href="#cc-unknown" /></svg>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-row">\n\t\t\t\t\t\t\t\t<div id="card-element"></div>\n\t\t\t\t\t\t\t\t<div id="card-errors" role="alert"></div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t<div class="form-row">\n\t\t\t\t\t\t\t\t<div id="card-expiry"></div>\n\t\t\t\t\t\t\t\t<div id="card-expiry-errors" role="alert"></div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t<div class="form-row">\n\t\t\t\t\t\t\t\t<div id="card-cvc"></div>\n\t\t\t\t\t\t\t\t<div id="card-cvc-errors" role="alert"></div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t\n\t\t\t\t\t<svg width="119" height="26"><use xlink:href="#pay-with-stripe-logo" /></svg>';

			return { fields: fields, html: html };
		}
	}, {
		key: 'complete',
		value: function complete() {
			return { html: '' };
		}
	}, {
		key: 'confirm_details',
		value: function confirm_details() {
			var last_step = this.steps[this.steps.length - 1],
			    html = '<div class="col-md-12">\n\t\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t\t<h4>' + this.content['payment-successful'] + ', <a href="/user/login"><u>' + this.content['payment-successful-click-here'] + '</u></a></h4>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>';

			return { title: last_step.title, submit: last_step.submit, html: html };
		}
	}, {
		key: 'return_html',
		value: function return_html(fields) {
			var html = "";

			for (var i in fields) {
				var field = fields[i],
				    label = this.form.combine_input('label', '', field.label, 3),
				    input = this.form.combine_input(field.type, field.name, '', 6, field.required),
				    group = this.form.form_group(label + input);

				html += group;
			}

			return { fields: fields, html: html };
		}
	}, {
		key: 'save_details',
		value: function save_details(post, step) {
			this.steps[step - 1].saved = post;
		}
	}, {
		key: 'process_payment_form',
		value: function process_payment_form(post) {
			return new Promise(function (resolve, reject) {
				$.post('/user/process_payment_form/', post, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'validate',
		value: function validate(field, value) {
			return this.form.validate(field, value);
		}
	}]);

	return Payment;
}(_Stripe3.default);

exports.default = Payment;

},{"./Form":4,"./Stripe":7}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Model class ResolutionCenter
 */
var ResolutionCenter = function () {
	function ResolutionCenter(initial_list, $content, $sce) {
		_classCallCheck(this, ResolutionCenter);

		this.initial_list = initial_list;
		this.content = $content;
		this.sce = $sce;
	}

	_createClass(ResolutionCenter, [{
		key: 'getInitialList',
		value: function getInitialList() {
			return this.initial_list;
		}
	}, {
		key: 'getRequestList',
		value: function getRequestList() {
			var list = [];

			for (var i in this.content) {
				if (i.indexOf('request-assistance-list') != -1) {
					list.push(this.content[i]);
				}
			}

			return list;
		}
	}, {
		key: 'requestCallPost',
		value: function requestCallPost($post) {
			return new Promise(function (resolve, reject) {
				$.post('/user/assistance/request-a-call', $post, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'resolveSelectSecond',
		value: function resolveSelectSecond(group_id) {
			return new Promise(function (resolve, reject) {
				$.post('/user/portal/resolution_center_post/', { group_id: group_id }, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'getGroupById',
		value: function getGroupById(group_id) {
			return new Promise(function (resolve, reject) {
				$.post('/user/portal/resolution_center_post/', { group_id: group_id }, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'getArticle',
		value: function getArticle(article_id) {
			return new Promise(function (resolve, reject) {
				$.post('/user/portal/resolution_center_post/', { article_id: article_id }, function (data) {
					resolve(data);
				});
			});
		}
	}]);

	return ResolutionCenter;
}();

exports.default = ResolutionCenter;

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Stripe = function () {
	function Stripe(pricing, payment_type, content, sce, stripe) {
		_classCallCheck(this, Stripe);

		this.publish_key = stripe.publish_key;
		this.secret_key = stripe.secret_key;
		this.stripeActive = false;
		this.pricing = pricing;
		this.stripe;
		this.paymentRequest;
		this.paymentDetails;

		this.content = content;

		console.log('Pricing - ', this.pricing);

		this.form_elements = ['number', 'expiry', 'cvc'];
		this.brand = 'unknown';
		this.creditCards = {
			'unknown': 'cc-unknown',
			'visa': 'cc-visa-2',
			'mastercard': 'cc-mastercard-2',
			'amex': 'cc-amex',
			'jcb': 'cc-jcb',
			'discover': 'cc-discover',
			'diners': 'cc-diners-club'
		};
	}

	_createClass(Stripe, [{
		key: 'setup_payment_details',
		value: function setup_payment_details(stripe, paymentRequest, paymentDetails) {
			this.stripe = stripe;
			this.paymentRequest = paymentRequest;
			this.paymentDetails = paymentDetails;

			var style = this.style(),
			    elements = this.stripe.elements(),
			    form_elements = this.form_elements,
			    prButton = elements.create('paymentRequestButton', { paymentRequest: paymentRequest }),
			    form = $('#stripe-payment');

			form_elements['number'] = elements.create('cardNumber', { style: style, hideIcon: false, iconStyle: 'solid', placeholder: this.content['billing-setup-card-number'] }), form_elements['expiry'] = elements.create('cardExpiry', { style: style, placeholder: this.content['billing-setup-card-expiry'] }), form_elements['cvc'] = elements.create('cardCvc', { style: style, placeholder: 'CVC' }),
			//postcode 	= elements.create('postalCode', {style: style, placeholder: this.content['billing-setup-postcode']}),

			form_elements['number'].mount('#card-element');
			form_elements['expiry'].mount('#card-expiry');
			form_elements['cvc'].mount('#card-cvc');
			//postcode.mount('#postcode');

			this.stripeActive = true;

			this.onCardNumberChange(form_elements['number']);
		}
	}, {
		key: 'makePayment',
		value: function makePayment(token_id) {
			console.log('PRICE - ', this.pricing);

			var form = $('#stripe-payment'),
			    action = form.attr('action'),
			    paymentDetails = this.paymentDetails,
			    source = 'tok_' + this.brand,
			    pricing = this.pricing,
			    amount = pricing.price.join();

			paymentDetails.total.label = this.pricing.type;
			paymentDetails.total.amount = amount.replace(',', '');

			return new Promise(function (resolve, reject) {
				var post_data = {
					token: token_id,
					source: source,
					details: paymentDetails,
					pricing: pricing
				};

				$.post(action, post_data, function (response) {
					resolve(response);
				});
			});
		}
	}, {
		key: 'formOnSubmit',
		value: function formOnSubmit() {
			var _this = this;

			var that = this,
			    form_elements = this.form_elements,
			    form = $('#stripe-payment');

			return new Promise(function (resolve, reject) {
				_this.stripe.createToken(form_elements['number']).then(function (result) {
					if (result.error) {
						var errorElement = document.getElementById('card-errors');
					} else {
						that.tokenHandler(result.token).then(function (value) {
							resolve(value.token_id);
						});
					}
				});
			});
		}
	}, {
		key: 'tokenHandler',
		value: function tokenHandler(token) {
			// Insert the token ID into the form so it gets submitted to the server
			var form = $('#stripe-payment');
			var hiddenInput = document.createElement('input');

			return new Promise(function (resolve, reject) {
				hiddenInput.setAttribute('type', 'hidden');
				hiddenInput.setAttribute('name', 'stripeToken');
				hiddenInput.setAttribute('value', token.id);

				form.append(hiddenInput);

				resolve({ token_id: token.id });
			});
		}
	}, {
		key: 'onCardNumberChange',
		value: function onCardNumberChange(number) {
			var that = this;

			number.addEventListener('change', function (event) {
				//console.log('Card is changing - ', event);
				//console.log('card brand - ', event.brand);

				var brand = event.brand,
				    svg = $('svg.credit-cards');

				that.brand = brand;

				if (svg.attr('class').indexOf(that.creditCards[brand]) === -1) {
					svg.animate({
						opacity: 0
					}, 100, function () {
						svg.attr('class', 'credit-cards');
						svg.addClass(that.creditCards[brand]);

						$('svg.credit-cards use').attr('xlink:href', '#' + that.creditCards[brand]);
						svg.animate({
							opacity: 1
						}, 100);
					});
				} else {
					svg.attr('class', 'credit-cards');
					svg.addClass(that.creditCards[brand]);
				}
			});
		}
	}, {
		key: 'onCardConfirmPayment',
		value: function onCardConfirmPayment(confirmBtn) {
			confirmBtn.addEventListener('click', function (e) {
				console.log('Payment Button Clicked - ', e);
			});
		}
	}, {
		key: 'style',
		value: function style() {
			return {
				base: {
					fontFamily: '"Roboto", sans-serif',
					fontWeight: '300',
					fontSmoothing: 'antialiased',
					fontSize: '20px'
				}
			};
		}
	}]);

	return Stripe;
}();

exports.default = Stripe;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Model class User
 */
var User = function () {
    function User($http) {
        _classCallCheck(this, User);

        this.http = $http;
    }

    _createClass(User, [{
        key: 'getUserDetails',
        value: function getUserDetails() {
            return new Promise(function (resolve, reject) {
                resolve('This is coming from the user class get.');
            });
        }
    }, {
        key: 'login',
        value: function login(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/loginpost', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'checkMembership',
        value: function checkMembership(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/check_membership', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'register',
        value: function register(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/registerpost', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'forgotPassword',
        value: function forgotPassword(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/forgot-password', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword(data, url) {
            return new Promise(function (resolve, reject) {
                $.post(url, data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'setGuestPassword',
        value: function setGuestPassword(data, url) {
            return new Promise(function (resolve, reject) {
                $.post(url, data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'updateProfile',
        value: function updateProfile(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/my-account/update-profile', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'changePassword',
        value: function changePassword(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/change-password-post', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'samlAcceptTerms',
        value: function samlAcceptTerms(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/saml/policy-accepted', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            return new Promise(function (resolve, reject) {});
        }
    }]);

    return User;
}();

exports.default = User;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Abstract class Software
 */
var HowItWorks = function () {
    function HowItWorks($sce, content, brandColorType, brandCode, landing_page_images) {
        _classCallCheck(this, HowItWorks);

        this.sce = $sce;
        this.content = content;
        this.brandColorType = brandColorType;
        this.landing_page_images = landing_page_images;
        this.brandCode = brandCode;
    }

    _createClass(HowItWorks, [{
        key: 'feature',
        value: function feature() {
            var features = {
                id_monitoring: {
                    title: this.sce.trustAsHtml(this.content['features-id-monitoring-title']),
                    text: this.sce.trustAsHtml(this.content['features-id-monitoring-text']),
                    icon: '<i class="flaticon-globe"></i>',
                    svg: this.brandCode === 'ea_gma_ch' ? '#globe-2' : "#globe",
                    duration: '1s',
                    delay: '.1s',
                    anchor: 'id_monitoring',
                    description: {
                        text: this.sce.trustAsHtml(this.content['features-id-monitoring-description-text']),
                        image: '/images/generali/landing/' + this.brandColorType + '/' + this.landing_page_images.globe,
                        background: 'bg-gray',
                        position: 'right',
                        points: [this.sce.trustAsHtml(this.content['features-id-monitoring-description-point-1']), this.sce.trustAsHtml(this.content['features-id-monitoring-description-point-2']), this.sce.trustAsHtml(this.content['features-id-monitoring-description-point-3']), this.sce.trustAsHtml(this.content['features-id-monitoring-description-point-4'])]
                    }
                },
                pc_laptop: {
                    title: this.sce.trustAsHtml(this.content['features-pc-laptop-title']),
                    text: this.sce.trustAsHtml(this.content['features-pc-laptop-text']),
                    icon: '<i class="flaticon-laptop-1"></i>',
                    svg: this.brandCode === 'ea_gma_ch' ? '#laptop-2' : "#laptop-1",
                    duration: '1s',
                    delay: '.3s',
                    anchor: 'pc_laptop_protection',
                    description: {
                        text: this.sce.trustAsHtml(this.content['features-pc-laptop-description-text']),
                        image: '/images/generali/landing/' + this.brandColorType + '/' + this.landing_page_images.laptop,
                        background: 'bg-gray',
                        position: 'left',
                        points: [this.sce.trustAsHtml(this.content['features-pc-laptop-description-point-1']), this.sce.trustAsHtml(this.content['features-pc-laptop-description-point-2']), this.sce.trustAsHtml(this.content['features-pc-laptop-description-point-3']), this.sce.trustAsHtml(this.content['features-pc-laptop-description-point-4'])]
                    }
                },
                mobile_protection: {
                    title: this.sce.trustAsHtml(this.content['features-mobile-protection-title']),
                    text: this.sce.trustAsHtml(this.content['features-mobile-protection-text']),
                    icon: '<i class="flaticon-smartphone-1"></i>',
                    svg: this.brandCode === 'ea_gma_ch' ? '#mobile' : '#smartphone-1',
                    duration: '1s',
                    delay: '.5s',
                    anchor: 'mobile_protection',
                    description: {
                        text: this.sce.trustAsHtml(this.content['features-mobile-protection-description-text']),
                        image: '/images/generali/landing/' + this.brandColorType + '/' + this.landing_page_images.smartphone,
                        background: 'bg-gray',
                        position: 'right',
                        points: [this.sce.trustAsHtml(this.content['features-mobile-protection-description-point-1']), this.sce.trustAsHtml(this.content['features-mobile-protection-description-point-2']), this.sce.trustAsHtml(this.content['features-mobile-protection-description-point-3']), this.sce.trustAsHtml(this.content['features-mobile-protection-description-point-4'])]
                    }
                },
                assistance: {
                    title: this.sce.trustAsHtml(this.content['features-assistance-title']),
                    text: this.sce.trustAsHtml(this.content['features-assistance-text']),
                    icon: '<i class="flaticon-telemarketer"></i>',
                    svg: this.brandCode === 'ea_gma_ch' ? '#assistance' : '#telemarketer',
                    duration: '1s',
                    delay: '.7s',
                    anchor: 'id_assistance',
                    description: {
                        text: this.sce.trustAsHtml(this.content['features-assistance-description-text']),
                        image: '/images/generali/landing/' + this.brandColorType + '/' + this.landing_page_images.telemarketer,
                        background: 'bg-gray',
                        position: 'left',
                        points: [this.sce.trustAsHtml(this.content['features-assistance-description-point-1']), this.sce.trustAsHtml(this.content['features-assistance-description-point-2']), this.sce.trustAsHtml(this.content['features-assistance-description-point-3']), this.sce.trustAsHtml(this.content['features-assistance-description-point-4'])]
                    }
                }
            };

            for (var index in features) {
                features[index].description.icon = '<span class="icon-correct"></span>';
            }

            return features;
        }
    }]);

    return HowItWorks;
}();

exports.default = HowItWorks;

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HowItWorks2 = require('../abstract/HowItWorks');

var _HowItWorks3 = _interopRequireDefault(_HowItWorks2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Model class FeatureDetails
 */
var FeatureDetails = function (_HowItWorks) {
    _inherits(FeatureDetails, _HowItWorks);

    function FeatureDetails($sce, content, brandCode, brandColorType, landing_page_images) {
        var _ret2;

        _classCallCheck(this, FeatureDetails);

        var _this = _possibleConstructorReturn(this, (FeatureDetails.__proto__ || Object.getPrototypeOf(FeatureDetails)).call(this, $sce, content, brandColorType, brandCode, landing_page_images));

        if (typeof _this[brandCode] === 'function') {
            var _ret;

            return _ret = _this[brandCode](), _possibleConstructorReturn(_this, _ret);
        }

        return _ret2 = _this.general(), _possibleConstructorReturn(_this, _ret2);
    }

    _createClass(FeatureDetails, [{
        key: 'general',
        value: function general() {
            return this.feature();
        }
    }, {
        key: 'ea_gma_ch',
        value: function ea_gma_ch() {
            var features = this.feature();

            features.id_monitoring.icon = '<svg class="flag-icon"><use xlink:href="#globe-2" /></svg>';
            features.pc_laptop.icon = '<svg class="flag-icon"><use xlink:href="#laptop-2" /></svg>';
            features.mobile_protection.icon = '<svg class="flag-icon"><use xlink:href="#mobile" /></svg>';
            features.assistance.icon = '<svg class="flag-icon"><use xlink:href="#assistance" /></svg>';

            for (var index in features) {
                features[index].description.icon = '<svg class="flag-icon"><use xlink:href="#tick" /></svg>';
            }

            return features;
        }
    }]);

    return FeatureDetails;
}(_HowItWorks3.default);

exports.default = FeatureDetails;

},{"../abstract/HowItWorks":9}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormatHTML = function () {
	function FormatHTML() {
		_classCallCheck(this, FormatHTML);
	}

	_createClass(FormatHTML, [{
		key: 'contruct',
		value: function contruct() {}
	}, {
		key: 'showString',
		value: function showString(input) {
			var newInput = input,
			    markup = this.formatMarkup(),
			    pattern;

			if (newInput !== undefined) {
				for (var i in markup) {
					if (i != '{{{a' && i != '{{{div' && i != '{{{i') {
						var regex = new RegExp(i, 'gi');

						newInput = newInput.replace(regex, markup[i]);
					}

					if (i == '{{{div') {
						pattern = /{{{div/g;

						newInput = this.formatInternalMarkUp(pattern, newInput, i);
					}

					if (i == '{{{a') {
						pattern = /{{{a/g;

						newInput = this.formatInternalMarkUp(pattern, newInput, i);
					}

					if (i == '{{{i') {
						pattern = /{{{i/g;

						newInput = this.formatInternalMarkUp(pattern, newInput, i);
					}
				}
			}

			return newInput;
		}
	}, {
		key: 'formatInternalMarkUp',
		value: function formatInternalMarkUp(pattern, newInput, key) {
			var matches = newInput.match(pattern);

			for (var a in matches) {
				var sLink = newInput.substr(newInput.indexOf(key), newInput.length);

				sLink = sLink.substr(0, sLink.indexOf('}}}') + 3);

				var newLink = '<' + sLink.substr(3, sLink.indexOf('}}}') - 3) + '>',
				    regex = new RegExp(sLink, 'gi');

				newInput = newInput.replace(regex, newLink);
			}

			return newInput;
		}
	}, {
		key: 'formatMarkup',
		value: function formatMarkup() {
			return {
				'{{{p}}}': '<p>',
				'{{{\/p}}}': '</p>',
				'{{{h4}}}': '<h4>',
				'{{{\/h4}}}': '</h4>',
				'{{{u}}}': '<u>',
				'{{{\/u}}}': '</u>',
				'{{{ul}}}': '<ul>',
				'{{{ol}}}': '<ol>',
				'{{{li}}}': '<li>',
				'{{{\/li}}}': '</li>',
				'{{{\/ul}}}': '</ul>',
				'{{{\/ol}}}': '</ol>',
				'{{{strong}}}': '<strong>',
				'{{{\/strong}}}': '</strong>',
				'{{{br}}}': '<br />',
				'{{{a': '',
				'{{{\/a}}}': '</a>',
				'{{{i': '',
				'{{{\/i}}}': '</i>',
				'{{{div': '',
				'{{{\/div}}}': '</div>',
				'{{{table}}}': '<table>',
				'{{{\/table}}}': '</table>',
				'{{{thead}}}': '<thead>',
				'{{{\/thead}}}': '</thead>',
				'{{{th}}}': '<th>',
				'{{{\/th}}}': '</th>',
				'{{{td}}}': '<td>',
				'{{{\/td}}}': '</td>',
				'{{{tr}}}': '<tr>',
				'{{{\/tr}}}': '</tr>',
				'{{{tbody}}}': '<tbody>',
				'{{{\/tbody}}}': '</tbody>'
			};
		}
	}]);

	return FormatHTML;
}();

exports.default = FormatHTML;

},{}]},{},[3])

